import { footerColumns } from '@/mocks/homeData';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="contact" className="bg-foreground-900 text-background-50">
      {/* Main Footer */}
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-10 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <button onClick={scrollToTop} className="flex items-center gap-2 mb-5 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fingerprint-line text-background-50 text-lg" />
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold tracking-tight font-heading leading-tight">
                  Ardeun
                </span>
                <span className="text-[10px] text-background-400 leading-tight -mt-0.5">
                  Biometrics Corporation
                </span>
              </div>
            </button>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs mb-6">
              Biometric identity, verification and security solutions for the digital world.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full border border-background-700 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors">
                <i className="ri-linkedin-fill text-sm" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-background-700 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors">
                <i className="ri-twitter-x-fill text-sm" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-background-700 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors">
                <i className="ri-youtube-fill text-sm" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-background-700 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors">
                <i className="ri-instagram-line text-sm" />
              </a>
            </div>
          </div>

          {/* Link Columns */}
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-300 mb-4">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-400 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Newsletter */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-300 mb-4">
              Stay Connected
            </h4>
            <p className="text-sm text-background-400 mb-4">
              Subscribe for updates on biometric trust and security.
            </p>
            <form className="flex gap-2" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-3 py-2 text-sm bg-background-800/50 border border-background-700 rounded-lg text-background-100 placeholder:text-background-600 focus:outline-none focus:border-primary-400"
              />
              <button
                type="submit"
                className="px-3 py-2 bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors"
              >
                <i className="ri-arrow-right-line" />
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2025 Ardeun Biometrics Corporation. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              Privacy Policy
            </a>
            <span className="text-background-700">|</span>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              Terms of Service
            </a>
            <span className="text-background-700">|</span>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}